export const rateHistoryColumns = [
  { name: 'id', label: '', hidden: true },
  { name: 'date', label: 'Date' },
  { name: 'value', label: 'Rate' },
  { name: 'values', label: '', hidden: true },
];

export const expandableRateHistoryColumns = [
  { name: 'updatedAt', label: 'Date' },
  { name: 'action', label: 'Action' },
  { name: 'entityTitle', label: 'Created' },
];
